import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// import cn from 'classnames';

import ProgressBar from '../ProgressBar/ProgressBar';
import SelectYesNo from '../SelectYesNo/SelectYesNo';
import MultiSelect from '../MultiSelect/MultiSelect';
import { getAllergies } from '../../actions/allergy';
import styles from './Steps.module.css';

const Step8 = (props) => {
  const { 
    onSave, 
    stepsData, 
    getAllergies,
    allergiesData,
  } = props;

  const [allergies, setAllergies] = useState(stepsData.allergies || []);
  const [showAllergies, setShowAllergies] = useState();

  // console.log('===allergies', allergies);

  useEffect(() => {
    getAllergies();

    let showAllergies = null;

    if (stepsData.allergies !== undefined) {
      showAllergies = !!stepsData.allergies?.length;
    }
    setShowAllergies(showAllergies);
  }, []);

  const onChangeHandler = (value) => {
    setShowAllergies(value);
  };

  const onSaveHandler = () => {
    onSave({ 
      allergies: showAllergies ? allergies : [],
    });
  };

  // debugger;
  // console.log('===allergiesData?.length', allergiesData?.length);

  if (!allergiesData?.length) {
    return false;
  }

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar />
      <div className={styles.allergiesContent}>
        <div className={styles.stepHeader}>
          Do you have any allergies or intolerances?
        </div>
        <SelectYesNo 
          onChange={onChangeHandler}
          defaultValue={showAllergies}
        />
        {showAllergies && (
          <div className={styles.multiSelectWrapper}>
            <MultiSelect 
              options={allergiesData}
              onChange={setAllergies}
              initialValue={allergies}
              placeholder="Enter your allergy"
            />
          </div>
        )}
        <button
          className="green-button"
          onClick={onSaveHandler}
          disabled={showAllergies === undefined}
        >
          Next
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  allergiesData: store.allergy.allergiesData,
});

const mapDispatchToProps = {
  getAllergies,
};

export default connect(mapStateToProps, mapDispatchToProps)(Step8);